'use client';

import { Box } from '@chakra-ui/react';

import Mobile from './footer.mobile';
import Desktop from './footer.desktop';

const Footer = ({
  isTgBot,
  hasMobile = false,
}: {
  isTgBot?: boolean;
  hasMobile?: boolean;
}) => {
  return (
    <>
      <Box display={{ base: 'none', lg: 'block' }}>
        <Desktop />
      </Box>
      {hasMobile && (
        <Box display={{ base: 'block', lg: 'none' }}>
          <Mobile isTgBot={isTgBot} />
        </Box>
      )}
    </>
  );
};

export default Footer;
